import { render, staticRenderFns } from "./VehicleChoice.vue?vue&type=template&id=1429e984&scoped=true&"
import script from "./VehicleChoice.vue?vue&type=script&lang=js&"
export * from "./VehicleChoice.vue?vue&type=script&lang=js&"
import style0 from "./VehicleChoice.vue?vue&type=style&index=0&id=1429e984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1429e984",
  null
  
)

export default component.exports